"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ArrowCircle = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var helios_styles_1 = require("@carvana/helios-styles");
var styled_components_1 = __importDefault(require("styled-components"));
var directionMap = {
    left: '0deg',
    right: '180deg',
    up: '90deg',
    down: '-90deg'
};
var SVG = styled_components_1.default.svg(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  transform: rotate(", ");\n"], ["\n  transform: rotate(", ");\n"])), function (props) { return directionMap[props.direction]; });
var ArrowCircle = function (_a) {
    var _b = _a.size, size = _b === void 0 ? 24 : _b, _c = _a.color, color = _c === void 0 ? helios_styles_1.icon.default : _c, _d = _a.className, className = _d === void 0 ? '' : _d, _e = _a.direction, direction = _e === void 0 ? 'left' : _e, _f = _a.focusable, focusable = _f === void 0 ? true : _f;
    return ((0, jsx_runtime_1.jsx)(SVG, __assign({ width: size, height: size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", direction: direction, className: className, focusable: focusable }, { children: (0, jsx_runtime_1.jsx)("path", { fill: color, fillRule: "evenodd", d: "M12 3a9 9 0 1 0 0 18 9 9 0 0 0 0-18M1 12C1 5.925 5.925 1 12 1s11 4.925 11 11-4.925 11-11 11S1 18.075 1 12m11.707-4.707a1 1 0 0 1 0 1.414L10.414 11H16a1 1 0 1 1 0 2h-5.586l2.293 2.293a1 1 0 0 1-1.414 1.414l-4-4a1 1 0 0 1 0-1.414l4-4a1 1 0 0 1 1.414 0", clipRule: "evenodd" }) })));
};
exports.ArrowCircle = ArrowCircle;
var templateObject_1;
